"use strict";
/*******************************************************************************

    The class that defines encryption key

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionKey = void 0;
var Hash_1 = require("../common/Hash");
var Signature_1 = require("../common/Signature");
var EncryptionKey = /** @class */ (function () {
    /**
     * Constructor
     * @param app_name  The app name
     * @param height    The block height
     * @param value     Encryption key
     * @param validator Validator that owns this encryption key
     * @param signature Signature with the validator private key
     */
    function EncryptionKey(app_name, height, value, validator, signature) {
        this.app_name = app_name;
        this.height = height;
        this.value = value;
        this.validator = validator;
        if (signature !== undefined)
            this.signature = signature;
        else
            this.signature = new Signature_1.Signature(Buffer.alloc(Signature_1.Signature.Width));
    }
    /**
     * Collects data to create a hash.
     * @param buffer The buffer where collected data is stored
     */
    EncryptionKey.prototype.computeHash = function (buffer) {
        Hash_1.hashPart(Buffer.from(this.app_name), buffer);
        this.height.computeHash(buffer);
        this.value.computeHash(buffer);
        this.validator.computeHash(buffer);
    };
    /**
     * Verify that a signature with the validator address
     * @returns If OK, return true, otherwise return false.
     */
    EncryptionKey.prototype.verify = function () {
        return this.validator.verify(this.signature, this);
    };
    return EncryptionKey;
}());
exports.EncryptionKey = EncryptionKey;
//# sourceMappingURL=EncryptionKey.js.map